<div #dropdownRoot *ngIf="!isMobileOrTablet" class="container">
    <div #button
        xmAriaInvalid
        role="combobox"
        aria-haspopup="listbox"
        class="select-box"
        tabindex="0"
        [attr.aria-describedby]="ariaDescribedBy"
        [attr.aria-controls]="ariaLabelId"
        [attr.aria-owns]="ariaLabelId + '_dropdown_list'"
        [attr.aria-labelledby]="buttonAttrAriaLabel"
        [attr.aria-expanded]="expanded"
        [attr.aria-activedescendant]="ariaActiveDescendId"
        (click)="toggle()"
        (blur)="buttonOrListBlur($event)"
        [ngClass]="{'disabled': isDisabled}">
        <span [attr.id]="buttonAttrId" [innerHtml]="selection.label"></span>
        <xm-media-image *ngIf="!isDisabled" aria-hidden="true" class="arrow" [ngClass]="{'expanded': expanded}" [imageOptions]="caretImageOptions" center="vert" size="height"></xm-media-image>
    </div>
    <ul #listElement
        role="listbox"
        [attr.id]="ariaLabelId + '_dropdown_list'"
        [attr.aria-labelledby]="ariaLabelId"
        [ngClass]="{ 'hidden': !expanded }"
        [ngStyle]="listStyle">
        <li #itemElement
            class="option"
            *ngFor="let item of optionsList; let i = index"
            [attr.id]="item.label + i"
            [attr.tabindex]="item.selected ? 0 : -1"
            [attr.role]="item.isDecorator ? 'presentation' : 'option'"
            [attr.aria-hidden]="item.isDecorator ? 'true' : null"
            [attr.aria-selected]="item.selected"
            [ngClass]="{ 'focused': item.selected }"
            (click)="onOptionClick(item)"
            (blur)="buttonOrListBlur($event)" [innerHtml]="item.label"></li>
    </ul>
</div>
<select #nativeSelect
    xmAriaInvalid
    class="select-box"
    *ngIf="isMobileOrTablet"
    [attr.aria-labelledby]="buttonAttrAriaLabel"
    [attr.aria-describedby]="ariaDescribedBy"
    [ngStyle]="selectStyle"
    (blur)="buttonOrListBlur($event)">
    <option disabled selected *ngIf="placeholderItem">{{ placeholderItem.label }}</option>
    <option *ngFor="let item of optionsList" [attr.selected]="item.selected ? 'selected' : null"
        [attr.disabled]="item.isDecorator ? true : null" [innerHtml]="item.label"></option>
</select>
<xm-media-image aria-hidden="true" class="arrow" *ngIf="isMobileOrTablet" [ngClass]="{'expanded': expanded}" [imageOptions]="caretImageOptions" center="vert" size="height"></xm-media-image>
